export const findObject3DChildByName = (object: any, name: string) =>
  object.children.find((child) => child.name === name);

export const setMorphTarget = (mesh: any, key: string, value: any) => {
  if (!mesh) return;
  const idx = mesh.morphTargetDictionary[key];
  if (!idx) return;
  mesh.morphTargetInfluences[idx] = value;
};
